'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import AppContextSidebarContext, {
  AppContextSidebarContextContentProps,
  DEFAULT_APP_SIDEBAR_WIDTH,
} from './app-context-sidebar-context';
import { usePathname } from 'next/navigation';

export default function AppContextSidebarProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<AppContextSidebarContextContentProps>({});
  const [width, setWidth] = useState<string>(DEFAULT_APP_SIDEBAR_WIDTH);

  const pathname = usePathname();

  useEffect(() => {
    setIsOpen(false);
    setContent({ content: null, title: null, footer: null });
    setWidth(DEFAULT_APP_SIDEBAR_WIDTH);
  }, [pathname]);

  return (
    <AppContextSidebarContext.Provider value={{ isOpen, setIsOpen, content, setContent, width, setWidth }}>
      {children}
    </AppContextSidebarContext.Provider>
  );
}
